export default __webpack_public_path__ + "static/media/DAIF_Eco_Screen1_in-end.b1dabcf3.jpg";